// import { useParams } from 'react-router-dom'
import { navigateTo } from '@/api/BridgeApi'
import { MultiLineText } from '@/components/common/i18n'
import { IQuickCreditParams, ISimpleAccountResponse } from '@/domains/AccountDomain'
import // OKSign,
'@/domains/CommonDomain'
import { WEB_PAGE_NATIVE_ROUTES } from '@/domains/CommonDomain'
// import {
//   IBillPaymentAmountIdentity,
//   // IBillPaymentInquireRequest,
// } from '@/domains/version/V2/BillPaymentDomain'
import { useTrans } from '@/hooks/useTrans'
import { IRootState } from '@/modules'
import { simpleAccountSelector } from '@/modules/account/SimpleAccountModule'
import {
  billPaymentAmountActions,
  billPaymentAmountSelector,
  BILL_PAYMENT_AMOUNT,
  IBillPaymentAmountState,
  IBillPaymentAmountView,
} from '@/modules/version/V2/bill-payment/BillPaymentAmountModule'
// import {
//   billPaymentMainSelector,
//   IFlattenProductType,
// } from '@/modules/version/V2/bill-payment/BillPaymentMainModule'
import { getRupiahFormat } from '@/utils/currencyUtils'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

/*export const enum BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE {
  TICK_QUICK_CREDIT = 'TICK_QUICK_CREDIT',
  PAYING_QUICK_CREDIT = 'PAYING_QUICK_CREDIT',
  CHECK_QUICK_CREDIT_LIMIT = 'CHECK_QUICK_CREDIT_LIMIT',
  QUICK_CREDIT_ERROR = 'QUICK_CREDIT_ERROR',
}*/
export const BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE = {
  TICK_QUICK_CREDIT: 'TICK_QUICK_CREDIT',
  PAYING_QUICK_CREDIT: 'PAYING_QUICK_CREDIT',
  CHECK_QUICK_CREDIT_LIMIT: 'CHECK_QUICK_CREDIT_LIMIT',
  QUICK_CREDIT_ERROR_INSUFFICIENT: 'QUICK_CREDIT_ERROR_INSUFFICIENT',
  QUICK_CREDIT_ERROR_CANNOT_BE_USED: 'QUICK_CREDIT_ERROR_CANNOT_BE_USED',
}
type qcBannerKey = keyof typeof BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE
export type BillPaymentQuickCreditBannerType = typeof BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE[qcBannerKey]

const billBannerClassName = 'bill-banner'
const bannerContainer = {
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.TICK_QUICK_CREDIT]: '',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.PAYING_QUICK_CREDIT]: `${billBannerClassName}-checkd`,
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.CHECK_QUICK_CREDIT_LIMIT]: `${billBannerClassName}-apply`,
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_INSUFFICIENT]: `${billBannerClassName}-error`,
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_CANNOT_BE_USED]: `${billBannerClassName}-error`,
}
const bannerIcon = {
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.TICK_QUICK_CREDIT]: 'ic-enabled',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.PAYING_QUICK_CREDIT]: 'ic-enabled',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.CHECK_QUICK_CREDIT_LIMIT]: '',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_INSUFFICIENT]: 'ic-disabled',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_CANNOT_BE_USED]: 'ic-disabled',
}
const bannerTitle = {
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.TICK_QUICK_CREDIT]:
    'billpayment_quick_credit_banner_title_tick',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.PAYING_QUICK_CREDIT]:
    'billpayment_quick_credit_banner_title_paying',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.CHECK_QUICK_CREDIT_LIMIT]:
    'billpayment_quick_credit_banner_title_check_limit',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_INSUFFICIENT]:
    'billpayment_quick_credit_banner_title_error_insufficient',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_CANNOT_BE_USED]:
    'billpayment_quick_credit_banner_title_error_cannot_be_used',
}
const bannerDescription = {
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.TICK_QUICK_CREDIT]:
    'billpayment_quick_credit_banner_desc_tick',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.PAYING_QUICK_CREDIT]:
    'billpayment_quick_credit_banner_desc_paying',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.CHECK_QUICK_CREDIT_LIMIT]:
    'billpayment_quick_credit_banner_desc_check_limit',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_INSUFFICIENT]:
    'billpayment_quick_credit_banner_desc_error_insufficient',
  [BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_CANNOT_BE_USED]:
    'billpayment_quick_credit_banner_desc_error_cannot_be_used',
}

export const BillPaymentQuickCreditBanner = () => {
  const $ = useTrans()
  const dispatch = useDispatch()
  const { qcBannerType: type } = useSelector<IRootState, IBillPaymentAmountView>(state =>
    billPaymentAmountSelector.view(state),
  )
  // const { productTypeCode } = useParams<IBillPaymentAmountIdentity>()
  // const { productTypeSwitchId, productTypeIdentifierType } = useSelector<
  //   IRootState,
  //   IFlattenProductType
  // >(state => billPaymentMainSelector.flattenProductType(state, productTypeCode))
  // const { customerId } = useSelector<IRootState, IBillPaymentAmountState>(
  //   state => state[BILL_PAYMENT_AMOUNT],
  // )

  const majorAccount = useSelector<IRootState, ISimpleAccountResponse>(state =>
    simpleAccountSelector.majorAccount(state),
  )

  const containerClassName = classNames(billBannerClassName, bannerContainer[type])

  const isDefault = type === BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.TICK_QUICK_CREDIT
  const isPaying = type === BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.PAYING_QUICK_CREDIT
  const isCheckLimit = type === BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.CHECK_QUICK_CREDIT_LIMIT
  const isError =
    type === BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_INSUFFICIENT ||
    type === BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.QUICK_CREDIT_ERROR_CANNOT_BE_USED

  const [amountQc, setAmount] = useState<string>('')
  const totalAmountNum = useSelector<IRootState, number>(state =>
    billPaymentAmountSelector.totalAmountNum(state),
  )
  const { creditJan } = useSelector<IRootState, IQuickCreditParams>(state =>
    simpleAccountSelector.getQuickCreditInfo(state),
  )
  const { amount } = useSelector<IRootState, IBillPaymentAmountState>(
    state => state[BILL_PAYMENT_AMOUNT],
  )

  useEffect(() => {
    if (isDefault || isError) {
      setAmount(getRupiahFormat(creditJan))
    } else if (isPaying) {
      setAmount(getRupiahFormat(totalAmountNum))
    } else {
      setAmount('')
    }
  }, [isError, isPaying, isDefault, type, creditJan, totalAmountNum, amount])

  if (!type) {
    return <></>
  }

  const changeCheckState = () => {
    /* checkbox -> Banner Type : Tick <-> Paying */
    if (isDefault) {
      // const payload: IBillPaymentInquireRequest = {
      //   amount,
      //   customerId,
      //   productTypeCode,
      //   productTypeSwitchId,
      //   identifierType: productTypeIdentifierType,
      //   isDisbursal: OKSign.YES,
      //   lonAcctNo: majorAccount.lonAcctNo,
      // }
      // dispatch(validateBillAsync.post(payload))
      dispatch(
        billPaymentAmountActions.setView({
          qcBannerType: BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.PAYING_QUICK_CREDIT,
        }),
      )
      // 대표 계좌로 자동변경
      dispatch(
        billPaymentAmountActions.setAccount({
          selectedAccount: majorAccount,
        }),
      )
    } else if (isPaying) {
      dispatch(
        billPaymentAmountActions.setView({
          qcBannerType: BILL_PAYMENT_QUICK_CREDIT_BANNER_TYPE.TICK_QUICK_CREDIT,
        }),
      )
    } else {
      return
    }
  }

  const onClick = () => {
    navigateTo(WEB_PAGE_NATIVE_ROUTES.CHECK_LIMIT, false)
  }

  return (
    <div className={containerClassName}>
      <span className={bannerIcon[type]} />
      <span className={'txt'}>
        <em>{$(bannerTitle[type])}</em>
        <MultiLineText>{$(bannerDescription[type], [amountQc])}</MultiLineText>
      </span>
      {(isDefault || isPaying) && (
        <span className={'ic-chk'}>
          <input
            type="checkbox"
            id="qc"
            className="ic-chk__ipt"
            onChange={changeCheckState}
            checked={isPaying}
          />
          <label htmlFor="qc" className="ic-chk__lb">
            chk
          </label>
        </span>
      )}
      {isCheckLimit && (
        <span className={'apply'}>
          <button className={'btn-apply'} onClick={onClick}>
            Apply now
          </button>
        </span>
      )}
      {isError && <span className={'ic-error'} />}
    </div>
  )
}
